import { render } from "./CreateOrEdit.vue?vue&type=template&id=4217ec69&scoped=true&ts=true"
import script from "./CreateOrEdit.vue?vue&type=script&lang=ts"
export * from "./CreateOrEdit.vue?vue&type=script&lang=ts"

import "./CreateOrEdit.vue?vue&type=style&index=0&id=4217ec69&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4217ec69"]])

export default __exports__